import React, {
  ComponentType,
  createContext,
  JSXElementConstructor,
  ReactElement,
} from 'react';

import { WrenchTheme, Theme } from '@wds/styles';
import { createTheming, ThemeProvider } from 'react-jss';
import { ThemeName } from '../types';
import { HeaderTheme } from './theme';
import { WrenchHeaderTheme } from './themes';

const HeaderThemeMapper: Record<ThemeName, HeaderTheme> = {
  wrench: WrenchHeaderTheme,
};

const ThemeMapper: Record<ThemeName, Theme> = {
  wrench: WrenchTheme,
};

type ThemeProps = {
  theme?: ThemeName;
};

const ThemeContext = createContext<HeaderTheme>(WrenchHeaderTheme);
const theming = createTheming(ThemeContext);
const { ThemeProvider: HeaderThemeProvider, useTheme: useHeaderTheme } =
  theming;

const withHeaderTheme =
  <T extends object>(
    Component: ComponentType<T>
  ): JSXElementConstructor<T & ThemeProps> =>
  ({ theme, ...rest }: ThemeProps): ReactElement<T & ThemeProps> =>
    (
      <ThemeProvider theme={ThemeMapper.wrench}>
        <HeaderThemeProvider theme={HeaderThemeMapper.wrench}>
          <Component {...(rest as T)} />
        </HeaderThemeProvider>
      </ThemeProvider>
    );

export { HeaderThemeProvider, useHeaderTheme, withHeaderTheme };

export type { HeaderTheme, ThemeProps };
